$shm_hitalama_map_history_view $mol_page
	map $shm_hitalama_map
	close? null
	head /
		<= Title $mol_view
			sub / \История изменений
		<= Head_spacer $mol_view
		<= Undo $mol_button_minor
			title \Отменить
			enabled <= undo_enabled true
			click? <=> undo? null
		<= Redo $mol_button_minor
			title \Повторить
			enabled <= redo_enabled true
			click? <=> redo? null
		<= Close $mol_button_minor
			hint \Закрыть историю изменений
			click? <=> close?
			sub / <= Close_icon $mol_icon_close
	body /
		<= Events $mol_list
			rows <= event_rows /$mol_view
			Empty <= No_events $mol_view
				sub / \Изменений пока нет
		<= Earlier $mol_button_minor
			title \Показать предыдущие изменения
			enabled <= earlier_enabled false
			click? <=> earlier_load? null
	Event* $mol_button_minor
		click? <=> event_toggle*? null
		sub <= event_content* /$mol_view
	Event_summary* $mol_view
		sub /
			<= Event_title*
			<= Event_meta*
	Event_title* $mol_view
		sub / <= event_title* 
	Event_meta* $mol_view
		sub / <= event_meta* 
	Event_details* $mol_view
		sub / <= event_details* 
	expanded*? false
